// src/pages/accessrequest/AccessRequest.jsx
import AccessDetails from './components/AccessDetails';
import AccessPromo from './components/AccessPromo';

export default function AccessRequest() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      <div className="bg-white text-black rounded-xl shadow-xl w-full max-w-5xl flex flex-col md:flex-row overflow-hidden">
        <AccessDetails />
        <AccessPromo />
      </div>
    </div>
  );
}
